import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import Quote from '../../assets/quote.svg'

export default ({ quote, cite }) => {
    
    return (
        <Style>
            <q><Quote />{quote}<Quote /></q>
            { cite && <cite>{cite}</cite>}
        </Style>
    )
}


const Style = styled.blockquote.attrs(props => ({
    className: 'quote'
}))`
    margin: 0;
    padding: 0;
    text-align: center;

    q {
        font-size: 24px;
        text-align: center;
        position: relative;
        padding: 0 2em;
        display: block;

        &::before, &::after {
            content: none;
        }

        svg {
            position: absolute;
            top: 0;
            left: 0;

            ~ svg {
                left: inherit;
                right: 0;
                transform: rotate(180deg);
            }
        }
    }

    cite {
        font-weight: 600;
        font-size: 14px;
        display: block;
        font-style: normal;
        margin-top: 1em;
    }

`